import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    isNewsInq: false,
    isCustNtcInq: false, //알림서비스 1주일 조회결과시(메인), true
    isCustNtc3Inq: false, //알림서비스 3개월 조회결과시(알림서비스 메뉴), true

    ekycPageCallCnt: 0, //기업고객일 경우, 메인화면 접근시 최초 한번 호출

    operGroupCd: "",
    newsList: [],

    RBF0404L40: {}, //내계좌조회
    RBF0470140: {}, //환율정보
    RBF0401P40: {
      dataGrid: null,
    }, //PUSH발송내역조회(3개월조회결과)
    initRBF0401P40: {
      dataGrid: null,
    }, //PUSH발송내역조회(일주일 조회 결과)
    isCustNtc: false, // push 일주일내 수신여부
    accountList: {}, //전계좌
    makeQr: true, // 베트남 로그인시 대표출금계좌 QR 생성

    //내계좌정보(임시)
    fvrtAcnTmp: {},
    fvrtAcnTemplate: {
      rnum: -1,
      acno: "", //계좌번호
      acnoKnd: "", //계좌종류
      lnpSeqSerno: "", //정렬순서일련번호
      colrCdCtnt: "", //색상코드내용
      amtRepsntYn: "", //금액표시여부
      ttddRcdrwSumRepsntYn: "", //당일입출금합계표시여부
      drwotAblamtRepsntYn: "", //출금가능금액표시여부
      newYmdRepsntYn: "", //신규년월일표시여부
      acnStusRepsntYn: "", //계좌상태표시여부
      dpostIrtRepsntYn: "", //예금이율표시여부
      ctrcTrmRepsntYn: "", //계약기간표시여부
      updatYmdRepsntYn: "", //갱신년월일표시여부
      intPamtRepsntYn: "", //이자납입금액표시여부
      lnAmtRepsntYn: "", //대출금액표시여부
      lnBalRepsntYn: "", //대출잔액표시여부
      expirYmdRepsntYn: "", //만기년월일표시여부
    },

    //전계좌조회
    RBF0404F40: {},

    //Push설정정보조회
    RBF0404M40: {
      in: {
        userIndfr: "",
      },
      out: {},
    },
    //Push설정정보등록
    RBF0604M60: {
      in: {
        inputParamCommon: {
          pushRecvCnsntYn: "",
          rcdrwCnsntYn: "",
          prdctCnsntYn: "",
          anounCnsntYn: "",
          motpAuthCnsntYn: "",
          aprvalCnsntYn: "",
          gridRowCnt: 0,
          dataGrid: [],
        },
      },
      out: {},
    },

    pushNotiStupInfo: {
      pushRecvCnsntYn: "",
      rcdrwCnsntYn: "",
      prdctCnsntYn: "",
      anounCnsntYn: "",
      motpAuthCnsntYn: "",
      aprvalCnsntYn: "",
      gridRowCnt: 0,
      dataGrid: [],
    },
    pushNotiAcnoStupInfo: {
      acnoCnt: 0,
      dataGrid: [],
    },
  };
};

const main = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getLatestNews: state => {
      if (state.newsList.length > 0) return state.newsList[0];
      else return {};
    },
    getFvrtAcnTemplate: state => {
      return state.getFvrtAcnTemplate;
    },
    getPushNotiStupInfo: state => {
      return state.pushNotiStupInfo;
    },
    getPushNotiAcnoStupInfo: state => {
      return state.pushNotiAcnoStupInfo;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    setRBF0470140_init: state => {
      state.RBF0470140 = getDefaultState().RBF0470140;
    },
    setLatestNewsList: (state, payload) => {
      state.isNewsInq = true;
      state.newsList = Object.freeze(payload);
    },
    setRBF0470140: (state, payload) => {
      state.isExrtRateInq = true;
      state.RBF0470140 = payload;
    },
    setFvrtAcnTmp: (state, payload) => {
      state.fvrtAcnTmp = state.fvrtAcnTemplate;
      state.fvrtAcnTmp = {
        ...state.fvrtAcnTmp,
        ...payload,
        colrCdCtnt: payload.colrCdCtnt ? payload.colrCdCtnt : payload.acnoKnd == "1" ? (payload.acnoKnd2 == "3" ? "type1" : "type2") : "type3",
      };
    },
    setRBF0404M40: (state, payload) => {
      state.RBF0404M40 = payload;
    },
    setRBF0604M60: (state, payload) => {
      state.RBF0604M60 = payload;
    },
    setPushNotiStupInfo_init: state => {
      state.pushNotiStupInfo = getDefaultState().pushNotiStupInfo;
    },
    setPushNotiStupInfo: (state, payload) => {
      state.pushNotiStupInfo = payload;
    },
    setPushNotiAcnoStupInfo_init: state => {
      state.pushNotiAcnoStupInfo = getDefaultState().pushNotiAcnoStupInfo;
    },
    setPushNotiAcnoStupInfo: (state, payload) => {
      state.pushNotiAcnoStupInfo = payload;
    },
  },
  actions: {
    ACT_setLatestNews: async function ({ commit }, operGroupCd) {
      let isNewsInq = this.state.common.main.isNewsInq;

      if (this.state.common.main.operGroupCd != operGroupCd) {
        this.state.common.main.operGroupCd = operGroupCd;
        isNewsInq = false;
      }

      if (!isNewsInq) {
        await new Promise(resolve => {
          this._vm.$post(
            "/commonbiz/board/listsearch",
            {
              boardID: "001",
              displayCnt: "1",
              dmndCnt: "1",
              operGroupCd: operGroupCd,
            },
            function (response) {
              commit("setLatestNewsList", response.outItem.boardList);
              resolve(response);
            },
            function (response) {
              resolve(response);
            },
            null,
            null,
            false,
          );
        });
      }
    },
    ACT_setFvrtAcnTmp: (context, payload) => {
      context.commit("setFvrtAcnTmp", payload);
    },
    ACT_setExrtRate: function ({ commit }) {
      commit("setRBF0470140_init");

      new Promise(resolve => {
        this._vm.$post(
          "/intnfinac/exrt/ExrtInq",
          {},
          response => {
            commit("setRBF0470140", response.outItem);
            resolve(response);
          },
          response => {
            commit("setRBF0470140_init");
            resolve(response);
          },
        );
      });
    },

    //Push설정정보 init
    ACT_setPushNotiStupInfo_init: context => {
      context.commit("setPushNotiStupInfo_init");
    },
    //Push설정정보 Set
    ACT_setPushNotiStupInfo: (context, payload) => {
      context.commit("setPushNotiStupInfo", payload);
    },

    //Push설정계좌정보 init
    ACT_setPushNotiAcnoStupInfo_init: context => {
      context.commit("setPushNotiAcnoStupInfo_init");
    },
    //Push설정계좌정보 Set
    ACT_setPushNotiAcnoStupInfo: (context, payload) => {
      context.commit("setPushNotiAcnoStupInfo", payload);
    },
  },
};

export default main;
